import { Race } from "../../api/model";
import * as React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";

export interface RaceDataComponentProps {
    race: Race;
    images?: string[];
}


export default (props: RaceDataComponentProps) => {
    const { race, images } = props;
    console.log('RaceExtraDetail props', props);
    return (
        <Paper elevation={5} style={{ padding: 10 }}>
            <Typography variant="headline" gutterBottom>Detalles de entrega</Typography>
            <Grid container >
                <Grid item xs={12} sm={6}>
                    <strong>Motivo no firma:</strong>
                    <div>{race.motivoNoFirma || '-'}</div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <strong>Observación:</strong>
                    <div>{race.observationEntrega || '-'}</div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <strong>Recepción aclaración:</strong>
                    <div>{race.recepcionAclaracion || '-'}</div>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <strong>Recepción CI:</strong>
                    <div>{race.recepcionCi || '-'}</div>
                </Grid>
            </Grid>
            <Typography style={{ marginTop: 16 }}>Imágenes</Typography>
            
            <Grid container>
                {images && images.length > 0 ? (
                    images.map((img, idx) => (
                        <Grid item key={idx} style={{ margin: 8 }}>
                            <img src={img} alt={`race-img-${idx}`} style={{ maxWidth: 300, maxHeight: 300, borderRadius: 8 }} />
                        </Grid>
                    ))
                ) : (
                    <Grid item>
                        <span>No hay imágenes disponibles.</span>
                    </Grid>
                )}
            </Grid>
        </Paper>
    );
}


// WEBPACK FOOTER //
// ./src/components/race/RaceExtraDetail.tsx